const activeTransforms = {};
export function parseHtml(html) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  if (doc.head && doc.head.childNodes.length) {
    // Attempt to mitigate original reason for current path
    const fragment = document.createDocumentFragment();
    const headScripts = doc.head.querySelectorAll('script');
    Array.from(headScripts).forEach(headScript => {
      fragment.appendChild(headScript);
    });
    if (doc.body.firstChild) {
      doc.body.insertBefore(fragment, doc.body.firstChild);
    } else {
      doc.body.appendChild(fragment);
    }
  }

  // Put the extracted comments back into the body if any exist
  Array.from(doc.childNodes).reverse().forEach(node => {
    if (node.nodeType === 8) {
      doc.body.insertBefore(node, doc.body.firstChild);
    }
  });
  return doc;
}
function serializeHtml(doc) {
  if (!doc.body) {
    return '';
  }
  return doc.body.innerHTML;
}
export function applyDomFilters(html, transforms) {
  const doc = parseHtml(html);
  if (!doc.body) {
    return '';
  }
  transforms.forEach(transform => {
    transform(doc);
  });
  return serializeHtml(doc);
}
export function getHtmlTransforms(editor) {
  if (!activeTransforms[editor.id]) {
    activeTransforms[editor.id] = {
      preProcess: [],
      postProcess: []
    };
  }
  return activeTransforms[editor.id];
}
export function addPreProcessTransform(editor, transform) {
  const transforms = getHtmlTransforms(editor);
  transforms.preProcess.push(transform);
}
export function addPostProcessTransform(editor, transform) {
  const transforms = getHtmlTransforms(editor);
  transforms.postProcess.push(transform);
}
export const replaceNodes = (nodes, replaceNode) => {
  const nodesArr = Array.from(nodes);
  nodesArr.forEach(node => {
    if (node.parentNode) {
      const replacementNodes = replaceNode(node);
      if (replacementNodes instanceof NodeList) {
        Array.from(replacementNodes).forEach(childNode => {
          node.parentNode.insertBefore(childNode, node);
        });
        node.parentNode.removeChild(node);
      } else {
        node.parentNode.replaceChild(replacementNodes, node);
      }
    }
  });
};
export function getRemoveTransformsHandler(editor) {
  return () => {
    delete activeTransforms[editor.id];
  };
}